import ILLAStorage from "@illa-fe-utils/storage"

export const ILLABuilderStorage = new ILLAStorage(`ILLABuilder@0.0.0`, 5)

export const CUSTOM_STORAGE_PREFIX = "ILLABuilderCustomStorage"
